import React, { useState } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { v4 as uuid } from 'uuid'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Grid,
  makeStyles
} from '@material-ui/core'
import NoRecordImg from '../../../../images/noRecordFound.png'
import { ClinicStore } from '../../../../stores'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    boxShadow:'0 1px 8px 0 rgba(0,0,0,0.1)',
    borderBottomLeftRadius:'10px',
    borderBottomRightRadius:'10px',
    marginTop:'-15px',
    padding:'25px',
    '& .MuiCardContent-root:last-child':{
      paddingBottom:'0px !important'
    }
  },
  actions: {
    justifyContent: 'flex-end'
  },
  notFoundImage: {
    margin: '0 auto',
    display: 'flex',
    height: '200px',
    marginTop: '70px'
  }
}))

const LatestOrders = ({ className, ...rest }) => {
  const classes = useStyles()
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const { getClinicEarnings } = ClinicStore.useStoreActions(actions => ({
    ...actions.doctorDetails
  }))

  const { earningsList } = ClinicStore.useStoreState(state => ({
    ...state.doctorDetails
  }))

  React.useEffect(() => {
    getClinicEarnings({
      start_date: startDate,
      end_date: endDate,
      page_no: '1',
      rows_per_page: '100'
    })
  }, [])

  React.useEffect(()=>{
    if(startDate !== undefined ){
      getClinicEarnings({
        start_date: startDate,
        end_date: endDate,
        page_no: '1',
        rows_per_page: '100'
      })
    }
  },[startDate , endDate])

  // React.useEffect(() => {
  //   console.log(earningsList)
  // }, [earningsList])

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <h3 style={{fontSize:'16px', color:'#64666d', fontWeight:'600'}}>Earnings</h3>

      <Grid
        container
        direction="row">
        <Box style={{marginRight:'20px', marginBottom:'20px'}}>
          <KeyboardDatePicker
            variant="inline"
            format="DD-MM-YYYY"
            margin="normal"
            maxDate={new Date()}
            name="from"
            label="From"
            value={startDate}
            onChange={(e,value) => setStartDate(e)}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
            autoOk={true}
          />
        </Box>

        <Box style={{marginBottom:'20px'}}>
          <KeyboardDatePicker
            variant="inline"
            format="DD-MM-YYYY"
            margin="normal"
            maxDate={new Date()}
            name="to"
            label="To"
            value={endDate}
            onChange={(e,value) => setEndDate(e)}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
            autoOk={true}
          />
        </Box>
      </Grid>

      <Divider />
      <PerfectScrollbar>
        <Box minWidth={800}>
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>Ref ID</TableCell> */}
                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>Doctor</TableCell>
                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>From date</TableCell>
                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>To date</TableCell>

                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>Amount</TableCell>
                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>Fees</TableCell>
                <TableCell style={{fontFamily:'Poppins',color:'rgba(55,55,55,0.6)',fontWeight:'600'}}>Services</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(earningsList || []).map(order => (
                <TableRow hover key={order.id}>
                  {/* <TableCell>{order.ref}</TableCell> */}
                  <TableCell style={{fontFamily:'Poppins'}}>{order.doctor}</TableCell>
                  <TableCell style={{fontFamily:'Poppins'}}>{order.startdate}</TableCell>
                  <TableCell style={{fontFamily:'Poppins'}}>{order.enddate}</TableCell>
                  <TableCell style={{fontFamily:'Poppins'}}>{order.amount}</TableCell>
                  <TableCell style={{fontFamily:'Poppins'}}>{order.fees}</TableCell>
                  <TableCell style={{fontFamily:'Poppins'}}>{order.services}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {(earningsList || []).length == 0 ? (
            <img
              src={NoRecordImg}
              className={classes.notFoundImage}
              alt={'Not found!'}
            />
          ) : (
            ''
          )}
        </Box>
      </PerfectScrollbar>
      <Box display="flex" justifyContent="flex-end" p={2}>
        {/* <Button
          color="primary"
          endIcon={<ArrowRightIcon />}
          size="small"
          variant="text">
          View all
        </Button> */}
      </Box>
    </Card>
  )
}

LatestOrders.propTypes = {
  className: PropTypes.string
}

export default LatestOrders
